import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft, Mail, Wrench } from "lucide-react";
import { api, formatError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("Falls die E-Mail existiert, ist ein Link unterwegs");
    } catch (err) {
      toast.error(formatError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="forgot-password-page"
      className="flex min-h-screen items-center justify-center px-6 bg-grid"
    >
      <div className="w-full max-w-md border border-white/10 bg-[#0d0d10] p-10">
        <Link to="/" className="flex items-center gap-3">
          <div className="flex h-9 w-9 items-center justify-center bg-[#FF4B00]">
            <Wrench className="h-5 w-5 text-white" strokeWidth={2} />
          </div>
          <span className="font-[Chivo] text-sm font-black uppercase tracking-widest">
            Admin
          </span>
        </Link>

        <div className="mt-10">
          <span className="tag-orange">Passwort vergessen</span>
          <h1 className="mt-4 text-3xl font-black uppercase">Reset anfordern</h1>
          <p className="mt-2 text-sm text-white/60">
            Wir schicken Ihnen einen Link zum Zurücksetzen des Passworts.
          </p>
        </div>

        {sent ? (
          <div className="mt-8 border border-[#10B981] bg-[#10B981]/10 p-5">
            <p className="text-sm text-white">
              Falls ein Konto mit dieser E-Mail existiert, ist der Reset-Link
              jetzt unterwegs. Bitte prüfen Sie Ihr Postfach.
            </p>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-8 space-y-5">
            <div>
              <Label className="mono text-[11px] uppercase tracking-widest text-white/60">
                E-Mail
              </Label>
              <Input
                data-testid="forgot-email"
                type="email"
                className="mono mt-2 border-white/20 bg-black text-white"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <button
              data-testid="forgot-submit"
              type="submit"
              disabled={loading}
              className="mt-2 inline-flex w-full items-center justify-center gap-2 bg-[#FF4B00] px-6 py-3 text-xs font-bold uppercase tracking-widest text-white hover:bg-[#E64300] disabled:opacity-40"
            >
              <Mail className="h-4 w-4" strokeWidth={2.5} />
              {loading ? "Sende..." : "Reset-Link senden"}
            </button>
          </form>
        )}

        <Link
          to="/admin/login"
          data-testid="back-to-login"
          className="mono mt-8 flex items-center gap-2 text-[10px] uppercase tracking-[0.2em] text-white/50 hover:text-white"
        >
          <ArrowLeft className="h-3.5 w-3.5" />
          Zurück zum Login
        </Link>
      </div>
    </div>
  );
}
